<div class="notifications-menu-container">
  <div class="notifications-menu-title-container">
    <div class="notifications-menu-title">Notifications</div>
    <div class="notifications-menu-title-icon">
      @if (unreadCount() > 0) {
        <mat-chip class="chip-basic-item">{{ unreadCount() }} new</mat-chip>
      }
    </div>
  </div>
  <div class="notifications-top-container">
    <div class="notifications-icon-container">
      <mat-icon class="notifications-icon extra-large-icon">notifications</mat-icon>
    </div>
    <div class="notifications-info-container">
      @if (unreadCount() > 0) {
        <div class="notifications-count">You have {{ unreadCount() }} new notification{{ unreadCount() === 1 ? '' : 's' }}</div>
      } @else {
        <div class="notifications-count">No new notifications</div>
      }
    </div>
  </div>
  <div>
    <mat-divider class="notifications-menu-divider"></mat-divider>
  </div>
  @for (message of messages(); track message.id; let last = $last) {
    <div class="notifications-middle-container" (click)="openMessage(message)">
      @if (!message.isRead) {
        <div class="notifications-middle-container-icon" (click)="markAsRead(message, $event)" matTooltip="Mark as read">
          <mat-icon class="notifications-icon">mark_email_unread</mat-icon>
        </div>
      } @else {
        <div class="notifications-middle-container-icon-read">
          <mat-icon class="notifications-icon">email</mat-icon>
        </div>
      }
      <div class="notifications-middle-container-text">
        <div class="notifications-middle-container-text-title" [class.unread]="!message.isRead">@if (message.title) { {{ message.title }} } @else { <em>(Untitled)</em> }</div>
        <div class="notifications-middle-container-text-from">{{ message.sentByUserFullName }}</div>
        @if (message.companyName) {
          <div class="notifications-middle-container-text-company">{{ message.companyName }}</div>
        }
        <div class="notifications-middle-container-text-message line-clamp-2" [innerHTML]="message.messageText | linkify"></div>
      </div>
    </div>
    @if (!last) {
      <mat-divider class="notifications-item-divider"></mat-divider>
    }
  }
  @if (messages().length === 0) {
    <div class="notifications-middle-container">
      <div class="notifications-middle-container-text">
        <div class="notifications-middle-container-text-message">No messages yet</div>
      </div>
    </div>
  }
  <!-- <div>
    <mat-divider class="notifications-menu-divider"></mat-divider>
  </div>
  <div class="notifications-bottom-container">
    <button mat-flat-button class="nrg-tertiary-flat-button see-all-notifications-button" (click)="onSeeAllNotifications()">
      See all notifications
    </button>
  </div> -->
</div>
